<template>
  <div class="box">
    <uni-popup ref="popup" type="bottom">
      <uni-card :note="true" :is-full="true" title="写病历">
        <div class="record_wrap">
          <div v-if="canNotEdit" class="show_wrap">
            <div class="title">
              <span>{{ currentDetail.hospitalName }}远程协作病历</span>
            </div>
            <div v-if="!['28922'].includes(this.hospitalID)" class="patientoutrecord">
              <span class="text">
                {{ currentDetail.patientOutRecordIdFromHIS || '' }}
              </span>
            </div>
            <div class="prescrip-wrap">
              <div class="special">
                <span>
                  咨询号：
                  <span>{{ reginfo.visitNo || '' }}</span>
                </span>
                <span class="visitNum">
                  咨询号：
                  <span>{{ reginfo.visitID }}</span>
                </span>
              </div>
              <div class="prescrip-msg">
                <span>
                  姓名：
                  <span>{{ currentDetail.patientName }}</span>
                </span>
                <span>
                  性别：
                  <span>
                    {{ getKeyValueText('sex_code', currentDetail.patientSex) }}
                  </span>
                </span>
              </div>
              <div class="prescrip-msg">
                <span>
                  年龄：
                  <span>{{ birthToAge(currentDetail.patientBirth) }}</span>
                </span>
                <span>
                  生日：
                  <span>{{ currentDetail.patientBirth }}</span>
                </span>
              </div>
              <div class="prescrip-msg">
                <span>
                  受者ID：
                  <span>{{ currentDetail.patientID }}</span>
                </span>
              </div>
              <div class="prescrip-msg">
                <span>
                  科室：
                  <span>{{ currentDetail.deptName }}</span>
                </span>
              </div>
              <div class="prescrip-msg">
                <span>
                  咨询时间：
                  <span>{{ currentDetail.actualVisitTime || '' }}</span>
                </span>
              </div>
            </div>
          </div>
          <div v-else class="patient_wrap">
            <div>
              <span>{{ currentDetail.patientName }}</span>
              <span>
                {{ getKeyValueText('sex_code', currentDetail.patientSex) }}
              </span>
              <span>{{ birthToAge(currentDetail.patientBirth) }}</span>
            </div>
            <div class="case_history" @click="prescription">
              <img src="@funcPuzzle/mini_doctor/add.png" class="case_img" />
              <!-- toLead -->
              <span class="case_text">导入病历</span>
            </div>
          </div>
          <uni-card :is-full="true">
            <uni-list-item title="初复咨询：" right-text="请选择" :disabled="canNotEdit">
              <template v-slot:righttext>
                <radio-group
                  :value="form.firstOrFollowVisit"
                  class="uni-list-cell uni-list-cell-pd"
                >
                  <label v-for="(item, i) in getKeyValue('firstOrFollowVisit')" :key="i">
                    <radio
                      color="#0089FF"
                      :value="item.code"
                      :checked="item.code == form.firstOrFollowVisit"
                      :disabled="canNotEdit ? true : false"
                    />
                    {{ item.value }}
                  </label>
                </radio-group>
              </template>
            </uni-list-item>
            <uni-list-item
              title="意识："
              :right-text="'请选择'"
              :clickable="true"
              :disabled="canNotEdit"
            >
              <template v-slot:righttext>
                <radio-group :value="form.consciousState" class="uni-list-cell uni-list-cell-pd">
                  <label v-for="(item, i) in getKeyValue('consciousState')" :key="i">
                    <radio
                      color="#0089FF"
                      :value="item.code"
                      :checked="item.code == form.consciousState"
                      :disabled="canNotEdit ? true : false"
                    />
                    {{ item.value }}
                  </label>
                </radio-group>
              </template>
            </uni-list-item>
            <uni-list-item
              title="病情："
              right-text="请选择"
              :clickable="true"
              :disabled="canNotEdit"
            >
              <template v-slot:righttext>
                <radio-group :value="form.illnessState" class="uni-list-cell uni-list-cell-pd">
                  <label v-for="(item, i) in getKeyValue('illness_state')" :key="i">
                    <radio
                      color="#0089FF"
                      :value="item.code"
                      :checked="item.code == form.illnessState"
                      :disabled="canNotEdit ? true : false"
                    />
                    {{ item.value }}
                  </label>
                </radio-group>
              </template>
            </uni-list-item>
          </uni-card>
          <div class="content">
            <div class="uni-textarea">
              <div>
                <span class="star">*</span>
                <span class="input_title">主诉：</span>
              </div>
              <textarea
                v-model="form.mainDiagnosis"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入主诉"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div class="uni-textarea">
              <span class="input_title">现病史：</span>
              <textarea
                v-model="form.medicalCurrentDesc"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入现病史"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div class="uni-textarea">
              <span class="input_title">既往史：</span>
              <textarea
                v-model="form.medicalHistoryDesc"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入既往史"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div class="uni-textarea">
              <span class="input_title">家族史：</span>
              <textarea
                v-model="form.familyHistoryDesc"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入家族史"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div class="uni-textarea">
              <span class="input_title">过敏史：</span>
              <textarea
                v-model="form.sensitiveHistoryDesc"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入过敏史"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div v-if="isTCM && medicine === 0" class="uni-textarea">
              <span class="input_title">中医望、闻、问诊：</span>
              <textarea
                v-model="form.fourMethods"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入中医望、闻、问诊"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div class="uni-textarea">
              <span class="input_title">体格检查：</span>
              <textarea
                v-model="form.bodyExam"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入体格检查"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div v-if="isTCM" class="uni-textarea">
              <span class="input_title">辅助检查：</span>
              <textarea
                v-model="form.assistantExam"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入辅助检查"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div v-if="isTCM && medicine === 0" class="uni-textarea">
              <span class="input_title">辩证依据：</span>
              <textarea
                v-model="form.evidences"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入辩证依据"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div v-if="isTCM && medicine === 0" class="uni-textarea">
              <span class="input_title">治则治法：</span>
              <textarea
                v-model="form.medicalRules"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入治则治法"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div class="uni-textarea input_wrap">
              <div class="row_wrap">
                <div>
                  <span class="star">*</span>
                  <span class="input_title">诊断：</span>
                </div>
                <img v-if="!canNotEdit" src="@funcPuzzle/mini_doctor/search.png" class="search" />
                <input
                  v-if="!canNotEdit"
                  :always-embed="true"
                  :disabled="canNotEdit"
                  type="text"
                  placeholder="请搜索诊断（疾病名称/拼音码）"
                  placeholder-style="color:#CECECE;font-size:.597333rem"
                  placeholder-class="input-placeholder"
                  @click="searchDiagnose"
                />
              </div>
            </div>
            <div v-if="list && list[0]" class="diagnose_wrap">
              <div v-if="!canNotEdit">
                <div v-for="(item, i) in list" :key="i" class="search_result">
                  <span :class="{ mdrug: item.symptomType === '3' }">
                    {{ item.diseaseName || item.symptomName }}
                  </span>
                  <span>{{ item.mainCode || item.symptomCode }}</span>
                  <span>【{{ getKeyValueText('symptom_type', item.symptomType) }}】</span>
                  <img
                    src="@funcPuzzle/mini_doctor/delete.png"
                    class="deleteDiagnose"
                    @click="deleteDiagnose(i)"
                  />
                </div>
              </div>
              <div v-else>
                <div v-for="(item, i) in finalList" :key="i" class="search_result">
                  <div class="savedDiagnose">
                    <span v-if="item.index === 0"
                      >{{ getKeyValueText('symptom_type', item.symptomType) + '诊断' }}：</span
                    >
                  </div>
                  <span>{{ item.mainCode || item.symptomCode }}</span>
                  <span :class="{ mdrug: item.symptomType === '3' }">
                    {{ item.diseaseName || item.symptomName }}
                  </span>
                </div>
              </div>
            </div>
            <div class="uni-textarea">
              <span class="input_title">复诊记录：</span>
              <textarea
                v-model="form.followVisitRecord"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入复诊记录"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div class="uni-textarea">
              <span class="input_title">建议：</span>
              <textarea
                v-model="form.doctorAdvice"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入建议"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div class="uni-textarea">
              <span class="input_title">处理意见：</span>
              <textarea
                v-model="form.management"
                maxlength="1000"
                :always-embed="true"
                :disabled="canNotEdit"
                placeholder="请输入处理意见"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <div class="doctor_name">
              <span class="title">医生签名：</span>
              <img
                v-if="currentDetail.doctorSignName"
                class="sign_name"
                :src="outImageFullPath(currentDetail.doctorSignName) + `?v=${new Date().getTime()}`"
              />
              <span v-else class="name">{{ currentDetail.doctorName }}</span>
            </div>
          </div>
        </div>
        <template v-slot:footer>
          <div class="foot">
            <div class="footer-box">
              <block v-if="btnText === '保存' && isTCM">
                <div class="cut" @click.stop="switchover">切换模板</div>
                <div class="save" @click.stop="writeRecord">保存</div>
              </block>
              <block v-else>
                <!-- v-if="currentDetail.visitState === '3'" -->
                <div
                  v-if="
                    currentDetail.visitState === '3' &&
                    !['28922', '28923', '28924', '28925', '28250'].includes(this.hospitalID)
                  "
                  class="cut"
                  @click.stop="certificateOfDiagnosis(currentDetail.id)"
                >
                  开诊断证明
                </div>
                <!-- :class="
                    currentDetail.visitState !== '3' ? 'savePlus' : 'save'
                  " -->
                <div
                  :class="currentDetail.visitState !== '3' ? 'savePlus' : 'save'"
                  @click.stop="writeRecord"
                >
                  {{ btnText }}
                </div>
              </block>
            </div>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-open-door
      ref="openTheDoor"
      v-model:visible="showDoor"
      :form-detail="form.mainDiagnosis"
      :open-list="list"
      @childByValue="childByValue"
    />
    <!-- 历史病历(导入)弹窗 -->
    <ms-medical-history
      ref="openTheHistory"
      :visible="showHistory"
      :current-detail="currentDetail"
      :reginfo="reginfo"
      :medicine="medicine"
      :isManageValue="isManageValue"
      :visitRecordType="form.visitRecordType"
      @historyClick="historyClick"
      @update:visible="isVisible = $event"
    />
    <!-- 历史病历(导入)弹窗 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  getKeyValueText,
  getKeyValue,
  birthToAge,
  outImageFullPath
} from '@/views/funcPuzzle/utils/util.js'
import { updateMedicalRecord, getBusinessConfig } from '@/views/funcPuzzle/utils/index.js'
import { isTCM } from '@/views/funcPuzzle/utils/business.js'
import msOpenDoor from '@/views/funcPuzzle/components/ms-open-door/ms-open-door.vue'
import msMedicalHistory from '@/views/funcPuzzle/components/ms-medical-history/ms-medical-history.vue'
import { signatureMethod } from '@/utils/signture/index.js'
import { ImagePreview } from 'vant'

export default {
  components: {
    msOpenDoor,
    msMedicalHistory
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    currentDetail: {
      type: [Object, String],
      default: ''
    },
    reginfo: {
      type: [Object, String],
      default: ''
    },
    myChildByValue: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    }
  },
  data() {
    return {
      isTCM: isTCM(),
      isManageValue: '',
      showDoor: false,
      showHistory: false,
      imgList: [
        {
          link: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ],
      form: {
        id: '',
        firstOrFollowVisit: '',
        consciousState: '',
        illnessState: '',
        mainDiagnosis: '',
        medicalCurrentDesc: '',
        medicalHistoryDesc: '',
        doctorAdvice: '',
        symptomName: [
          {
            symptomCode: '',
            symptomName: '',
            symptomType: ''
          }
        ],
        familyHistoryDesc: '',
        sensitiveHistoryDesc: '',
        management: '',
        bodyExam: '',
        visitRecordType: ''
      },
      canNotEdit: false,
      btnText: '保存',
      birthToAge,
      list: [],
      finalList: [],
      medicine: 0,
      urchin: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.popup.open()
      } else {
        this.close()
      }
    },
    canNotEdit(val) {
      this.btnText = val ? '编辑' : '保存'
    },
    currentDetail: {
      handler(val) {
        // uni.showToast({
        //   title: '数据加载中..',
        //   icon: 'none',
        //   mask: true
        // })
        if (val.mainDiagnosis) {
          this.canNotEdit = true
        } else {
          this.canNotEdit = false
        }
        this.form.firstOrFollowVisit = val.firstOrFollowVisit ? val.firstOrFollowVisit : '2'
        this.form.consciousState = val.consciousState ? val.consciousState : '1'
        this.form.illnessState = val.illnessState ? val.illnessState : '1'
        this.form.mainDiagnosis = val.mainDiagnosis
        this.form.medicalCurrentDesc = val.medicalCurrentDesc
        this.form.medicalHistoryDesc = val.medicalHistoryDesc
        this.form.familyHistoryDesc = val.familyHistoryDesc
        this.form.sensitiveHistoryDesc = val.sensitiveHistoryDesc
        this.form.bodyExam = val.bodyExam
        this.form.assistantExam = val.assistantExam
        this.form.followVisitRecord = val.followVisitRecord
        this.form.doctorAdvice = val.doctorAdvice
        this.form.management = val.management
        this.form.visitRecordType = val.visitRecordType
        // console.log(this.form.visitRecordType, '608')
        // console.log(val.visitRecordType, '607')
        this.form.fourMethods = val.fourMethods //中医望、闻、问诊回显
        this.form.evidences = val.evidences //辩证依据
        this.form.medicalRules = val.medicalRules //治则治法
        if (!val.symptomName) {
          this.list = []
        } else {
          const arr = JSON.parse(val.symptomName)
          if (
            !arr[0] ||
            (!arr[0].symptomCode && !arr[0].symptomType && arr[0].symptomName === '[]')
          ) {
            this.list = []
          } else {
            this.list = arr.map(item => {
              return {
                mainCode: item.symptomCode,
                diseaseName: item.symptomName,
                symptomType: item.symptomType
              }
            })

            this.finalList = this.handleList(this.list)

            const fish = this.list.findIndex(
              item => item.symptomType === '2' || item.symptomType === '4'
            )
            if (fish != -1) {
              this.medicine = 0
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getKeyValueText,
    getKeyValue,
    outImageFullPath,
    certificateOfDiagnosis(id) {
      uni.navigateTo({
        url: `/mine/certificateOfDiagnosis/certificateOfDiagnosis?id=${id}`
      })
    },
    childByValue(item) {
      // console.log('item', item, '646')
      this.medicine = item.medicine
      // console.log(this.medicine, '657')
      if (item.empty) {
        // 使用原始值重置form
        this.form = this.$options.data().form
        this.list = []
      }
      this.open()
      // switch (item.medicine) {
      //   case 0:
      //     if (item.empty) {
      //       this.form = {}
      //       this.list = []
      //     }
      //     this.open()
      //     break
      //   case 1:
      //     if (item.empty) {
      //       this.form = {}
      //       this.list = []
      //     }
      //     this.open()
      //     break
      // }
    },
    // 导入病历
    historyClick(item) {
      // console.log(item, 'item2')
      this.form.firstOrFollowVisit = item.firstOrFollowVisit || '2'
      this.form.consciousState = item.consciousState || '1'
      this.form.illnessState = item.illnessState || '1'
      this.form.mainDiagnosis = item.mainDiagnosis
      this.form.medicalHistoryDesc = item.medicalHistoryDesc
      this.form.medicalCurrentDesc = item.medicalCurrentDesc
      this.form.doctorAdvice = item.doctorAdvice
      this.form.familyHistoryDesc = item.familyHistoryDesc
      this.form.sensitiveHistoryDesc = item.sensitiveHistoryDesc
      this.form.management = item.management
      this.form.bodyExam = item.bodyExam
      this.form.visitRecordType = item.visitRecordType
      // console.log(this.form.visitRecordType, '689')

      this.form.symptomName = item.symptomName
      this.form.fourMethods = item.fourMethods //中医望、闻、问诊回显
      this.form.evidences = item.evidences //辩证依据
      this.form.medicalRules = item.medicalRules //治则治法
      this.form.followVisitRecord = item.followVisitRecord //复诊记录
      this.form.assistantExam = item.assistantExam //辅助检查
      this.list = JSON.parse(item.symptomName)
      // 判定是否为中医模板
      // const idiot = this.list.findIndex(ele => ele.symptomType == 2)

      // idiot === -1 ? (this.medicine = 1) : (this.medicine = 0)
      this.finalList = this.handleList(this.list)
      this.open()
    },
    prescription() {
      this.getTemplateManagement()
    },
    async getTemplateManagement() {
      // 是否显示病历模板tab 走业务字典配置
      const res = await getBusinessConfig('using_medical_record_template', this.hospitalID)
      if (res.code === 0) {
        if (res.DoctorServicePackageList && res.DoctorServicePackageList[0]) {
          this.isManageValue = res.DoctorServicePackageList[0].value
        }
      }

      this.close()

      this.showHistory = true
      this.$refs.openTheHistory.open()
      // console.log('this.form.visitRecordType', this.form.visitRecordType)
      // console.log(this.showHistory, 'this.showHistory')
    },
    groupBy(arr, key) {
      const obj = {}
      arr.sort((a, b) => a[key] - b[key])
      arr.map(item => {
        const _key = item[key]
        if (obj[_key]) {
          obj[_key].push(item)
        } else {
          obj[_key] = [item]
        }
      })
      return obj
    },
    handleList(val) {
      if (!val) {
        return []
      }
      this.arr = val
      const groupObj = this.groupBy(this.arr, 'symptomType')
      let finArr = []
      for (const i in groupObj) {
        finArr.push(groupObj[i])
      }

      finArr = finArr.map((item, i) => {
        item.sort((a, b) => a.symptomType - b.symptomType)
        item.map((item2, index2) => {
          item2.index = index2
          return item2
        })
        return item
      })

      return [].concat(...finArr)
    },
    reception() {
      if (!this.$refs.popup) {
        return false
      }
      this.$refs.popup.close()
    },
    open() {
      this.$nextTick(function () {
        // 第一次创建病历调用
        if (this.myChildByValue) {
          // console.log('this.myChildByValue', this.myChildByValue)
          this.medicine = this.myChildByValue
        }
      })
      this.$refs.popup.open()
    },
    close() {
      if (!this.$refs.popup) {
        return false
      }
      this.$emit('update:visible', false)
      // console.log('this.visible', this.visible)
      this.$refs.popup.close()
    },
    previewImg(index) {
      const imgList = this.imgList.map(item => {
        return outImageFullPath(item.link)
      })
      ImagePreview({
        images: imgList,
        startPosition: index,
        closeable: true
      })
      // uni.previewImage({
      //   current: index,
      //   urls: imgList
      // })
    },
    // 点击显示添加诊断弹窗
    searchDiagnose() {
      this.$refs.popup.close()
      this.$bus.emit('clickDiagnose', {
        val: true,
        type: {
          medicine: this.medicine,
          list: this.list
        }
      })
    },
    deleteDiagnose(i) {
      this.list.splice(i, 1)
    },
    writeRecord() {
      // 中医院传参
      if (this.isTCM) {
        // console.log(this.medicine, this.medicine === 0, 'this.medicine', '789')
        // medicine = 0 中医，1 西医; visitRecordType 参数：2 中医， 1：西医
        this.medicine === 0 ? (this.form.visitRecordType = '2') : (this.form.visitRecordType = '1')
      }

      if (this.btnText === '编辑') {
        // 点击编辑需要传递病历类型 诊断需要用到
        // console.log('currentDetail', this.currentDetail)
        // this.medicine = this.currentDetail.visitRecordType === '2' ? 1 : 0
        this.medicine = this.currentDetail.visitRecordType === '2' ? 0 : 1
        // console.log(this.medicine, 'this.medicine')
        this.canNotEdit = false
      } else {
        // console.log(
        //   'this.form',
        //   this.form,
        //   this.form.visitRecordType,
        //   'this.form.visitRecordType'
        // )
        // this.medicine = this.currentDetail.visitRecordType === '2' ? 0 : 1
        // return
        uni.showLoading({
          title: '保存中',
          icon: 'none'
        })

        if (!this.form.mainDiagnosis) {
          uni.showToast({
            title: '请输入主诉',
            icon: 'none'
          })
          return
        }
        this.form.symptomName = this.list.map(item => {
          return {
            symptomCode: item.mainCode || item.symptomCode,
            symptomName: item.diseaseName || item.symptomName,
            symptomType: item.symptomType
          }
        })
        const symptomStr = JSON.stringify(this.form.symptomName)
        if (symptomStr.length > 500) {
          uni.showToast({
            icon: 'none',
            title: '诊断过长，请编辑后重新提交'
          })
          return
        }
        this.form.id = this.currentDetail.id
        this.finalList = this.handleList(this.list)
        this.skunk()

        // console.log('859', this.isTCM, this.medicine, this.urchin)

        if (!this.form.symptomName[0]) {
          uni.hideLoading()
          uni.showToast({
            title: '请填写诊断',
            icon: 'none'
          })
          return false
        } else if (this.form.visitRecordType == 3) {
          //蒙文病历判断 需要填写西医诊断和蒙医诊断
          // console.log('visitRecordType', this.form.symptomName)
          const symptomName = this.form.symptomName || []
          const hasType3 = symptomName.some(item => item.symptomType === '3')
          const hasType1 = symptomName.some(item => item.symptomType === '1')
          if (!hasType1) {
            uni.hideLoading()
            uni.showToast({
              title: '请填写西医诊断',
              icon: 'none'
            })
            return false
          }
          if (!hasType3) {
            uni.hideLoading()
            uni.showToast({
              title: '请填写蒙医诊断',
              icon: 'none'
            })
            return false
          }
        } else if (this.isTCM && this.medicine === 0 && !this.urchin) {
          uni.hideLoading()
          uni.showToast({
            title: '请确保西医，中医，中医症型均已填写',
            icon: 'none'
          })
          return false
        }

        // console.log('updateMedicalRecord', this.form)

        updateMedicalRecord(this.form).then(res => {
          uni.hideLoading()

          if (res.code == '0') {
            this.canNotEdit = true
            this.$emit('refreshDetail', '')
          } else if (res.code === -4) {
            // TODO 20230215加 - 当期需求
            this.needSign(res)
            return
          }
          uni.showToast({
            title: res.codeDesc,
            icon: 'none',
            mask: true,
            duration: 3000
          })
        })
      }
    },

    // 需要签名，在这里
    needSign(res) {
      const _this = this
      const signMethod = new signatureMethod({
        flowId: res?.flowId, // e签宝使用，后台返回
        accountId: res?.accountId, // e签宝使用，后台返回
        prescripNum: res.prescripNum, // 处方编号，后台返回
        doctorId: res.doctorId, // 医生ID，后台返回
        signType: res.signType, // 签名类型，后台返回
        signUrl: res.signUrl, // 签名地址，后台返回
        businessType: res.businessType, // 1 开方，2审核，3发药，4病例，5诊疗
        response: res, // 后台返回的数据
        // 查询签名前调用的方法（提示用）
        beforeConfirm() {
          // afterCheckModel() 继续查询
          uni.showModal({
            title: '提示',
            content: '签名是否已完成？',
            cancelText: '取消',
            confirmText: '已完成',
            success: res => {
              if (res.confirm) {
                signMethod.afterCheckModel()
              } else {
                // this.canNotEdit = true
              }
            }
          })
        },
        // 签名成功时
        signSuccess() {
          _this.canNotEdit = false
          _this.$emit('refreshDetail', '')
        },
        // 签名失败时调用
        signFail() {
          _this.canNotEdit = true
        },
        // e签宝调用失败
        eSignFail() {
          uni.showToast({
            title: '调用e签宝小程序失败，请重试',
            icon: 'none'
          })
        }
      })
    },
    // 中医院中药处方判定
    skunk() {
      if (this.form.symptomName && this.form.symptomName.length < 3) return false
      // 西医诊断判定
      let checkpointOne = ''
      this.form.symptomName.forEach(item => {
        if (item.symptomType == '1') {
          checkpointOne = item.symptomType
        }
      })
      // 中医诊断判定
      let checkpointTwo = ''
      this.form.symptomName.forEach(item => {
        if (item.symptomType == '2') {
          checkpointTwo = item.symptomType
        }
      })
      // 中医症型判定
      let checkpointThree = ''
      this.form.symptomName.forEach(item => {
        if (item.symptomType == '4') {
          checkpointThree = item.symptomType
        }
      })
      if (checkpointOne === '') return false
      if (checkpointTwo === '') return false
      if (checkpointThree === '') return false
      this.urchin = true
    },
    switchover() {
      this.close()
      this.showDoor = true
      // this.$refs.openTheDoor.open()
    }
  },

  mounted() {
    this.$bus.on('diagnoseMsg', val => {
      this.$refs.popup.open()
      this.list = [].concat(val)
    })
  },
  unmounted() {
    this.$bus.off('clickDiagnose')
  }
}
</script>

<style lang="scss" scoped>
.drug ::v-deep .uni-card__header-title-text {
  text-align: center;
}
.drug >>> .uni-list-item__extra {
  width: 2.901333rem;
  height: 0.981333rem;
  border: 0.021333rem solid #7dd5b1;
  border-radius: 0.085333rem;
}
.record_wrap ::v-deep .uni-list-cell::after {
  background-color: transparent;
}
.record_wrap ::v-deep .uni-list-cell-pd {
  padding: 0;
  width: 6.933333rem;
  -webkit-justify-content: start;
  justify-content: start;
}
</style>
<style lang="scss" scoped>
.record_wrap {
  max-height: 19.2rem !important;
  overflow-y: scroll;
  overflow-x: hidden;
  .show_wrap {
    min-height: 11.946667rem;
    display: flex;
    flex-direction: column;
    .title {
      height: 3.2rem;
      text-align: center;
      font-size: 0.725333rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 1.706667rem;
      width: 8.704rem;
      align-self: center;
    }
    .patientoutrecord {
      border-bottom: 0.021333rem solid #ececec;
      padding: 0.341333rem 0 0.682667rem 0.682667rem;
      line-height: 1;
      .text {
        font-size: 0.64rem;
        font-weight: 400;
        color: #222222;
      }
    }
    .prescrip-wrap {
      height: 8.533333rem;
      padding: 0.64rem;
      .prescrip-msg {
        display: flex;
        margin-bottom: 0.853333rem;
        .visitNum {
          display: flex;
          flex-wrap: nowrap;
        }
        text {
          flex: 1;
          font-size: 0.597333rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #888;
          line-height: 0.853333rem;
          flex-wrap: nowrap;
          text:first-child {
            color: #222;
          }
        }
      }
      .special {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.853333rem;
        text {
          font-size: 0.597333rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #888;
          line-height: 0.853333rem;
          text:first-child {
            color: #222;
          }
        }
      }
    }
  }
  .patient_wrap {
    width: 100%;
    height: 2.389333rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 0.512rem;
    color: #222;

    .case_history {
      display: flex;
      align-items: center;
      padding-right: 0.682667rem;

      .case_img {
        width: 0.725333rem;
        height: 0.725333rem;
        margin: 0 0.128rem 0.085333rem;
      }

      .case_text {
        color: #0089ff;
        font-size: 0.64rem;
      }
    }

    text {
      font-size: 0.597333rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 0.853333rem;
      margin-right: 0.64rem;
    }
    text:first-child {
      font-size: 0.725333rem;
      line-height: 1.024rem;
    }
  }
}
.content {
  color: #888;
  line-height: 1.75;
  padding: 0 0.512rem;
  font-size: 0.597333rem;
  border-top: 0.021333rem solid #ececec;
  .diagnose_wrap {
    width: 100%;
    height: auto;
    border-bottom: 0.021333rem solid #ececec;
    .search_result {
      width: 100%;
      min-height: 1.92rem;
      display: flex;
      flex-wrap: wrap;
      padding-left: 0.64rem;
      padding-top: 0.426667rem;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      align-items: center;
      .deleteDiagnose {
        width: 0.768rem !important;
        height: 0.768rem !important;
      }
      text {
        margin-right: 0.213333rem;
      }
      .savedDiagnose {
        min-width: 3.2rem;
        font-size: 0.597333rem;
        font-weight: 400;
        color: #444444;
      }
    }
  }
  .input_wrap {
    padding-bottom: 0.426667rem;
    display: flex;
    flex-direction: column;
    .row_wrap {
      display: flex !important;
    }
    .search {
      width: 0.853333rem;
      height: 0.853333rem;
      margin-top: 0.042667rem;
    }
    input {
      width: 70%;
    }
  }
  .doctor_name {
    width: 100%;
    height: 4.266667rem;
    padding: 0.512rem 0;
    display: flex;
    align-items: center;
    .name {
      font-size: 0.725333rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 1.024rem;
    }
    .title {
      color: #222222;
    }
    .sign_name {
      width: 2.133333rem;
      height: 0.853333rem;
    }
  }
  .uni-textarea {
    display: flex;
    flex-direction: column;
    border-bottom: 0.021333rem solid #ececec;
    padding-top: 0.533333rem;
    .star {
      color: rgb(245, 108, 108);
      margin-right: 0.085333rem;
    }
    .input_title {
      min-width: 2.986667rem;
      font-size: 0.597333rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 0.853333rem;
      margin-bottom: 0.298667rem;
    }
    textarea {
      display: block;
      box-sizing: border-box;
      padding: 0.213333rem;
    }
  }
}
.foot {
  padding-bottom: 0.853333rem;
  .footer-box {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    font-size: 0.682667rem;
    // height: .64rem;
    // padding-bottom: 1.28rem;

    .cut {
      width: 6.933333rem;
      height: 1.834667rem;
      border: 0.021333rem solid #0089ff;
      border-radius: 1.834667rem;
      color: #0089ff;
      text-align: center;
      line-height: 1.834667rem;
      margin-right: 0.682667rem;
    }

    .save,
    .savePlus {
      width: 6.976rem;
      height: 1.877333rem;
      background-color: #0089ff;
      border-radius: 1.877333rem;
      color: #fff;
      line-height: 1.877333rem;
      text-align: center;
    }
    .savePlus {
      width: 14.634667rem;
    }
  }
}

.btn {
  display: inline-block;
  background: #0089ff;
  width: 100%;
  line-height: 1.877333rem;
  color: #fff;
  font-size: 0.682667rem;
  border-radius: 1.877333rem;
}
</style>
